module.exports = __webpack_public_path__ + "static/media/ss14.0aaf62d0.jpg";